import { EventDrivenStore } from '@core/store/eventDrivenStore';
import constants from '@core/utils/constants';

class Store extends EventDrivenStore {
  constructor() {
    super('country', {
      selectionRequestId: null,
      countryChoices: [],
      activeChoice: null,
      currencySelectionRequestId: null,
      currencyChoices: [],
      activeCurrencyChoice: null,
      isMultiCurrencySelection: false,
      selectedCurrencies: [],
      preselectedCurrencies: []
    });
  }

  async setupEvents() {
    this.on(constants.EVENTS.COUNTRY.SELECT, (data) => {
      this.state.selectionRequestId = data.id;
      this.state.activeChoice = null;
      this.state.countrySearch = '';
    });

    this.on(constants.EVENTS.COUNTRY.SELECTION_CLICKED, (data) => {
      if (this.state.activeChoice?.countryCode == data.countryCode) {
        this.state.activeChoice = null;
      } else this.state.activeChoice = data;
    });

    this.on(constants.EVENTS.CURRENCY.SELECT, (data) => {
      this.state.currencySelectionRequestId = data.id;
      this.state.activeCurrencyChoice = null;
      this.state.isMultiCurrencySelection = data.multiSelect || false;

      // Handle preselected currencies
      if (data.preselected) {
        this.state.preselectedCurrencies = Array.isArray(data.preselected)
          ? data.preselected
          : [data.preselected];
      } else {
        this.state.preselectedCurrencies = [];
      }

      // Initialize selected currencies based on preselected
      this.state.selectedCurrencies = [...this.state.preselectedCurrencies];
    });

    this.on(constants.EVENTS.CURRENCY.SELECTION_CLICKED, (data) => {
      if (this.state.isMultiCurrencySelection) {
        // Multi-selection mode
        const index = this.state.selectedCurrencies.indexOf(data.code);
        if (index > -1) {
          // Remove from selection
          this.state.selectedCurrencies.splice(index, 1);
        } else {
          // Add to selection
          this.state.selectedCurrencies.push(data.code);
        }
      } else {
        // Single selection mode
        if (this.state.activeCurrencyChoice?.code == data.code) {
          this.state.activeCurrencyChoice = null;
        } else {
          this.state.activeCurrencyChoice = data;
        }
      }
    });

    this.on(constants.EVENTS.CURRENCY.MULTI_SELECT, (enabled) => {
      this.state.isMultiCurrencySelection = enabled;
      if (!enabled) {
        // Reset to single selection mode
        this.state.selectedCurrencies = [];
      }
    });
  }
}

// new Store();
export default Store;
